import type { PropsWithChildren } from 'react'
import React from 'react'
import { useTheme } from '@mui/material'
import useFavurTranslation from 'hooks/useFavurTranslation'
import CloseButton from 'redesign/components/atoms/Buttons/CloseButton'
import PinForgottenButton from 'redesign/components/atoms/Buttons/pin-forgotten-button'
import RedesignThemeWrapper from 'redesign/components/atoms/RedesignThemeWrapper'
import Header from 'redesign/components/organisms/Header'
import Page from 'redesign/components/templates/Page'
import PinLoginContent from 'redesign/components/templates/pin-login-content'
import routes from 'services/RoutesProvider/routes'
import PinLoadingContent from '../../components/templates/pin-loading-content/pin-loading-content'
import SecureConnectionDialogPage from '../secure-connection-dialog-page'
import { usePinLogin } from './use-pin-login'

const PinLogin: React.FC<PropsWithChildren> = ({ children }) => {
  const { t } = useFavurTranslation()
  const { palette } = useTheme()
  const {
    componentRendered,
    loadingActive,
    history,
    pinState,
    startTyping,
    closeSnackbar,
    displaySecureConnectionPage,
    isSmallScreen,
  } = usePinLogin()

  if (displaySecureConnectionPage) {
    return <SecureConnectionDialogPage />
  }

  if (loadingActive) {
    return <PinLoadingContent />
  }

  if (componentRendered) return <>{children}</>

  return (
    <RedesignThemeWrapper>
      <Page
        fullContentHeight
        fullContentWidth
        showHamburgerHeader={false}
        hideNativeNavigation
        header={
          <Header
            backgroundColor={palette.background.default}
            withoutDivider
            endContent={<CloseButton onClick={history.goBack} />}
          />
        }
        footer={
          <PinForgottenButton isSmallScreen={isSmallScreen} onClick={() => history.push(routes.pinReset)} t={t} />
        }
      >
        <PinLoginContent
          isSmallScreen={isSmallScreen}
          pinState={pinState}
          startTyping={startTyping}
          closeSnackbar={closeSnackbar}
        />
      </Page>
    </RedesignThemeWrapper>
  )
}

export default PinLogin
